const LOGIN_TOKEN_KEY = 'erxesLoginToken';
const LOGIN_REFRESH_TOKEN_KEY = 'erxesLoginRefreshToken';
export const CHAT_SCREEN_URL = '/chat-screen';

export const SITE_KEY = '6LdJGj8eAAAAAGUif4dW6F8t3qXh3AmfXF80Ki-0'

var CHAT_URL = 'http://localhost:3200/chatbot.html';
var DASHBOARD_URL;
var REACT_APP_API_SUBSCRIPTION_URL;
var REACT_APP_API_URL;
var REACT_FS_SERVER_HOST;
var email;
var password;
var userID;
export default {
  LOGIN_TOKEN_KEY,
  LOGIN_REFRESH_TOKEN_KEY
};



// WEBPACK FOOTER //
// src/consts.js